import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';

import 'Components/Account/AccountPage.scss';
import 'Components/Account/AccountModal.scss';
import AccountNavigation from 'Components/Account/AccountNavigation';
import WishlistSaleSection from 'Containers/HomePage/WishlistSaleSection';
import { toggleLoginModal } from 'Redux/ducks/modal';
import store from 'Redux/store';
import Route from 'Containers/App/Route';
import ErrorBoundary from 'Components/Utility/ErrorBoundary';

function AccountRoute({ component: Component, authenticated, ...rest }) {
  const intl = useIntl();

  const ExtensionMidPageBanner = lazy(() => import(/* webpackChunkName: "AssistantBanner" */ 'Components/Banner/ExtensionMidPageBanner'));

  if (!authenticated) {
    // Do autologin and stay on route if doLogin parameter set
    store.dispatch(toggleLoginModal());
    return false;
  }

  return (<Route
    {...rest}
    noPrerender
    render={props => (
      <main className="account-page">
        <div className="container">
          <div className="account-content-container">
            <div className="account-content-left-container">
              <AccountNavigation {...props} />
            </div>
            <div className="account-content-right-container">
              <ErrorBoundary>
                <Component fromAccount intl={intl} {...props} />
              </ErrorBoundary>
            </div>
          </div>

          <Suspense>
            <ExtensionMidPageBanner appearsOn="account" />
          </Suspense>
          <WishlistSaleSection isAccount />
        </div>
      </main>
    )}
  />);
}

AccountRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
  authenticated: PropTypes.bool,
};

AccountRoute.defaultProps = {
  component: null,
  authenticated: false,
};

export default connect(({ auth: { authenticated } }) => ({ authenticated }))(AccountRoute);
